<template>
    <div class="co-painel-configuracoes-notificacao-organizacao">
        <configuracao-titulo titulo="Organização"/>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailAssinarDoc"
                :label="`Permitir envio de E-mails ao assinar documentos.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailFormalizarDoc"
                :label="`Permitir envio de E-mails ao formalizar documentos.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailExcluirDoc"
                :label="`Permitir envio de E-mails ao excluir ${$tc('pt_br.documento', 2).toLowerCase()}.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
            <v-tooltip top max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-icon size="18" color="#999" class="ml-1" v-on="on">mdi-information</v-icon>
                </template>
                Notificará sempre que um {{ $tc("pt_br.documento").toLowerCase() }} for excluido da plataforma.
            </v-tooltip>
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailEtapaAssinarDoc"
                :label="`Permitir envio de E-mails ao finalizar etapas de assinatura dos documentos.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailRejeitarDoc"
                :label="`Permitir envio de E-mails ao rejeitar a assinatura dos documentos.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailCancelarDoc"
                :label="`Permitir envio de E-mails ao cancelar documentos.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailProximoLimiteAssinaturaDoc"
                :label="`Permitir envio de E-mails de limite de prazo para assinatura próximo a encerrar.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
        </v-row>

        <v-row no-gutters class="mx-3">
            <v-switch
                color="primary"
                v-model="value.emailConviteAssinaturaNomeOrganizacao"
                :label="`Utilizar nome da organização para identificação no convite de assinatura.`"
                :disabled="ehPlanoSemEdicaoConfiguracaoNotificacao"
            />
            <v-tooltip top max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-icon size="18" color="#999" class="ml-1" v-on="on">mdi-information</v-icon>
                </template>
                Ao desativar essa configuração, no texto de notificação de convite para assinatura será usado o nome do usuário que está gerando o {{ $tc("pt_br.documento").toLowerCase() }}.
            </v-tooltip>
        </v-row>
    </div>
</template>

<script>

import ConfiguracaoTitulo from '../../common/ConfiguracaoTitulo'

export default {
    name: 'NotificacoesOrganizacao',
    components: {ConfiguracaoTitulo},
    props: {
        value: {
            required: true
        },
        ehPlanoSemEdicaoConfiguracaoNotificacao: {
            type: Boolean,
            required: true
        }
    }
}
</script>
